// This currently does not account for different users !!
// So the first person that signs up on a device will get tutorials.

import { selectCurrentActiveAlive } from "slices/efficeTreeSlice";
import { selectHelperList, setHelperList } from "slices/generalSlice";
import { selectSpaceBoxActive } from "slices/spaceMediaSlice";

// which is enough for now
let dispatch = null;
let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  getState = module.store.getState;
});

const EFS_FRESHMAN_WATCH = "efs_freshman_watch_";
export const FM_JOINORCREATE = "FM_JOINORCREATE";
export const FM_BRANCHES = "fm_branches";
export const FM_ENTERSPACEBUTTON = "fm_enterspacebutton";
export const FM_GOHOME = "fm_gohome";
export const FM_INPUTENTRY = "fm_inputentry";
export const FM_DRAGAVATAR = "fm_dragavatar";
export const FM_EXPANDVIDEOS = "fm_expandvideos";
export const FM_SHAREDEVICES = "fm_sharedevices";
export const FM_SHOUT = "fm_shout";
export const FM_FOCUS = "fm_focus";
export const FM_SIDEVIDEOS = "fm_sidevideos";
export const FM_MINIMISESPACE = "fm_minimisespace";
export const FM_CENTRALEFFICES = "fm_centraleffices";
export const FM_PERSONALSETTINGS = "fm_personalsettings";

const homeList = [FM_JOINORCREATE, FM_CENTRALEFFICES, FM_PERSONALSETTINGS];

const inEfficeList = [FM_BRANCHES, FM_CENTRALEFFICES, FM_PERSONALSETTINGS];

const spaceList = [FM_DRAGAVATAR, FM_SHOUT];

function setAsFreshman() {
  localStorage.setItem("freshman", Date.now());
}

// Set in local storage when the freshman arrived
export function freshmanHere() {
  if (localStorage.getItem("freshman") === null) setAsFreshman();
}

// check if freshman (without calling localstorage everytime)
let memoisedResult = null;
export function isFreshman() {
  if (memoisedResult !== null) return memoisedResult;
  let freshmanDay = localStorage.getItem("freshman");
  // within past week we guide them
  // if they have not encountered certain parts of the app they will still be notified within this time
  memoisedResult = freshmanDay && Date.now() - freshmanDay < 1653440000;
  return memoisedResult;
}

// Set that the freshman has watched a certain helper
export function setFreshmanWatched(helperName) {
  localStorage.setItem(makeFManLSkey(helperName), "true");
}
export function batchSetFreshmanWatched() {
  let helperNames = selectHelperList(getState());
  helperNames.forEach((helperName) =>
    localStorage.setItem(makeFManLSkey(helperName), "true")
  );
}
export function unsetFreshmanWatched(helperName) {
  localStorage.removeItem(makeFManLSkey(helperName));
}
export function unsetAllFreshmanWatched() {
  homeList
    .concat(inEfficeList)
    .concat(spaceList)
    .forEach((helper) => unsetFreshmanWatched(helper));
}

// Determines if the freshman has watched a particular helper
export function freshmanWatched(helperName) {
  return localStorage.getItem(makeFManLSkey(helperName)) !== null;
}

export function resetFreshman() {
  unsetAllFreshmanWatched();
  setAsFreshman();
  if (selectSpaceBoxActive(getState())) startSpaceHelpers();
  else if (
    !selectSpaceBoxActive(getState()) &&
    selectCurrentActiveAlive(getState())
  ) {
    startInEfficeHelpers();
  } else startHomeHelpers();
}

// Make the freshman localstorage key for a given helper variable
function makeFManLSkey(helperName) {
  return EFS_FRESHMAN_WATCH + helperName;
}

// Creates the list of helpers that will be watched in succession when these
// functions are called.

export const startHomeHelpers = () => startList(homeList);
export const startInEfficeHelpers = () => startList(inEfficeList);
export const startSpaceHelpers = () => startList(spaceList);

function startList(proposedList) {
  let helperList = proposedList.filter((helper) => !freshmanWatched(helper));
  if (helperList.length > 0) dispatch(setHelperList(helperList));
}

// For dev and debugging
window.efs_freshmanHere = freshmanHere;
window.efs_isFreshman = isFreshman;
window.efs_unsetFreshmanWatched = unsetFreshmanWatched;
window.efs_unsetAllFreshmanWatched = unsetAllFreshmanWatched;
window.efs_startHomeHelpers = startHomeHelpers;
window.efs_startInEfficeHelpers = startInEfficeHelpers;
window.efs_startSpaceHelpers = startSpaceHelpers;
